import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { KeyboardModel, MapOxxoTopicOne, MonitorIntroTopicTwo } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { GoldCoin } from "../objects/Topics/TopicTwo/GoldCoin";
import { ButtonScreenPoint } from "../objects/Topics/TopicTwo/ButtonScreenPoint";
import { PinPad } from "../objects/Topics/TopicTwo/PinPad";
import { Tarjeta } from "../objects/Topics/TopicTwo/Tarjeta";

export class SceneTopicTwo extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.monitorTopic = new MonitorIntroTopicTwo(this.loadingManager)

		this.keyboard = new KeyboardModel(this.loadingManager)
		this.keyboard.visible = false
		this.add(this.keyboard)

		this.coin = new GoldCoin(this.loadingManager)
		this.coin.visible = false
		this.add(this.coin)

		this.buttonPointerScreen = new ButtonScreenPoint(this.loadingManager)
		this.buttonPointerScreen.rotation.y = -1.5343
		this.add(this.buttonPointerScreen)

		this.pinPad = new PinPad(this.loadingManager);
		this.pinPad.visible = false
		this.add(this.pinPad)

		this.tarjeta = new Tarjeta(this.loadingManager);
		// this.tarjeta.visible = false
		this.add(this.tarjeta)
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}


	resetActOne() {
		this.characterSelected.visible = false
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic2.actScene, (step = "") => {
			switch (step) {
				case "reboot_1":
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.A)
					this.coin.clearAnimation()
					this.coin.visible = false
					break;
				case "move_client_1":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				case "move_desk_1":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true

					});
					break;
				case "view_keyboard":
					this.camera.moveCameraToPoint(new Vector3(-12.0343, -0.5031, -1.9074), 1, new Vector3(-11.139, -0.55, -1.464), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.keyboard.visible = true
					this.keyboard.position.set(-11.2, -0.6, -1.2)
					this.keyboard.rotation.set(1.6, 0, 2.1)
					this.keyboard.onAnimate(this.keyboard.A)
					break;
				case "hidden_keyboard":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.A)
					break;
				case "view_money":
					this.camera.moveCameraToPoint(new Vector3(-12.0343, -0.5031, -1.9074), 1, new Vector3(-11.139, -0.55, -1.464), () => {
						// this.camera.control.minDistance = 0.6;
						// this.camera.control.maxDistance = 2;
					});
					this.coin.position.set(-11.4, -0.6, -1.3)
					this.coin.rotation.set(0, -1, 1.6)
					this.coin.scale.set(12, 12, 12)
					this.coin.onAnimate()
					this.coin.visible = true
					break;
				case "hidden_money":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.coin.clearAnimation()
					this.coin.visible = false
					break;
				default:
					this.resetActOne()
					break;
			}
		})

	}
	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		this.monitorTopic.visible = true
		this.monitorTopic.initMonitor()
		this.monitorTopic.scale.x = 1.333
		this.add(this.monitorTopic)

		ObserverEmitter.on(EVENTS.tema6.topic2.actScene, (step = "") => {
			switch (step) {
				case "reboot_2":
					this.monitorTopic.selectTexture(this.monitorTopic.namesTextures.topic2_act2_01)
					this.buttonPointerScreen.position.set(-11.566, 0.13, 2.85)
					this.buttonPointerScreen.visible = true
					this.pinPad.visible = false
					this.tarjeta.removeCard()
					this.tarjeta.visible = true
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.T)
					break;
				case "move_client":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true

					});
					break;
				case "move_monitor":
					this.characterSelected.visible = false
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.camera.control.minDistance = 1.4;
						this.camera.control.maxDistance = 2;
					});
					break;
				case "animation_pinpad":
					this.characterSelected.visible = false
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
						this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
						this.camera.control.minPolarAngle = MathUtils.degToRad(20);
						this.camera.control.minDistance = 1.5;
						this.camera.control.maxDistance = 1.9;
					});
					ObserverEmitter.emit(EVENTS.tema6.topic2.listenScene, "move_pinpad")

					this.pinPad.visible = true
					this.pinPad.position.set(-10.85, -0.97, 0.078)
					this.tarjeta.insertCard()
					// Wait for the animations
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic2.listenScene, "move_keyboard")
						this.keyboard.position.set(-11.3, -0.99, -0.8)
						this.keyboard.rotation.set(0, -1.57, 0)
						this.keyboard.visible = true
						this.keyboard.onAnimate(this.keyboard.T)
						this.camera.moveCameraToPoint(new Vector3(-11.4931, -0.5144, -0.7973), 1, new Vector3(-11.205, -1.261, -0.797), () => {
							this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
							this.camera.control.minPolarAngle = MathUtils.degToRad(20);
							this.camera.control.minDistance = 0.75;
							this.camera.control.maxDistance = 1.05;
						});
					}, 3000);
					break;
				case "remove_animations":
					this.pinPad.visible = false
					this.tarjeta.visible = false
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.T)
					break;
				case "texture_monitor_1":
					this.monitorTopic.selectTexture(this.monitorTopic.namesTextures.topic2_act2_01)
					this.buttonPointerScreen.position.set(-11.566, 0.13, 2.85)
					break;
				case "texture_monitor_2":
					this.monitorTopic.selectTexture(this.monitorTopic.namesTextures.topic2_act2_02)
					this.buttonPointerScreen.position.set(-11.566, 0.13, 2.74)
					break;
				case "texture_monitor_3":
					this.monitorTopic.selectTexture(this.monitorTopic.namesTextures.topic2_act2_03)
					this.buttonPointerScreen.visible = false
					break;
				case "texture_monitor_4":
					this.buttonPointerScreen.visible = true
					this.buttonPointerScreen.position.set(-11.566, -0.11, 2.93)
					break;
				default:
					this.resetActOne()
					break;
			}
		})

	}
	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		this.monitorTopic.visible = true
		this.monitorTopic.initMonitor()
		this.monitorTopic.scale.x = 1.333
		this.add(this.monitorTopic)

		ObserverEmitter.on(EVENTS.tema6.topic2.actScene, (step = "") => {
			switch (step) {
				case "move_client":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true

					});
					break;
				default:
					this.resetActOne()
					break;
			}
		})

	}


	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
